import type Phaser from "phaser";

import { SKIN_COUNT } from "../config";
import { registerAvatarAnimations } from "../entities/Avatar";
import type { Appearance } from "../types";
import { CATALOG, appearanceCode } from "./catalog";
import { avatarPartsReady, composeSheet } from "./composer";

/**
 * Chave de textura (ja com animacoes registradas) para um jogador. Fantasmas
 * usam o sprite de fantasma; sem aparencia — ou se as partes nao carregaram —
 * cai no preset avatar_N.
 */
export function avatarTextureKey(
  scene: Phaser.Scene,
  info: { skin: number; appearance?: Appearance | null; ghost?: boolean },
): string {
  if (info.ghost) return "ghost";
  const fallback = `avatar_${Math.min(Math.max(info.skin, 0), SKIN_COUNT - 1)}`;
  if (!info.appearance || !avatarPartsReady()) return fallback;

  const key = `look:${appearanceCode(info.appearance)}`;
  if (scene.textures.exists(key)) return key;

  let sheet: HTMLCanvasElement;
  try {
    sheet = composeSheet(info.appearance);
  } catch (error) {
    console.warn("não foi possível compor o avatar; usando o preset", error);
    return fallback;
  }
  const texture = scene.textures.addCanvas(key, sheet);
  if (!texture) return fallback;

  const { width, height, cols, rows } = CATALOG.frame;
  for (let frame = 0; frame < cols * rows; frame++) {
    texture.add(frame, 0, (frame % cols) * width, Math.floor(frame / cols) * height, width, height);
  }
  registerAvatarAnimations(scene, key);
  return key;
}
